import { useState, useEffect } from 'react';
import PRELOAD_IMG from '../../img/video-overlay.png';

export default function Media(props: {medium: any, setResource: any, setMediaViewer: any}) {

    const [mediaWindow, setmediaWindow] = useState(false);
    const prefix = 'https://ucts.nyc3.digitaloceanspaces.com/';

    const downloadIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15M9 12l3 3m0 0l3-3m-3 3V2.25" />
    </svg>;
    const eyeIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
    </svg>

    const bookIcon = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
    </svg>

    const showMedia = (enlace : any) => {
        fetch(process.env.REACT_APP_API_URL+'media/show', {
            method: "POST",
            body: JSON.stringify({media: enlace}),
            headers: {
              'Content-Type': 'Application/json',
              'Token': 'Bearer CfXpCr4EgS0gmDQbO252ML4NkysrJTiJsh1AuDe0a3834909',
              'Access-Control-Allow-Origin': 'https://app.vax-connect.com'
            }
          })
            .then(async response => {
                let text = await response.text();
                console.log(text)
                props.setResource(text);
                props.setMediaViewer(true);
            })
            .catch(e => alert('Código inválido'));
    }

    if(props.medium.extension === 'SOUND'){
        return (
            <>
                <audio controls>
                    <source src={props.medium.enlace} type="audio/mpeg" />
                    Your browser does not support the audio tag.
                </audio>
            </>
        )
    }

    if(props.medium.extension === '.pdf'){
        return (
            <>
                <a className="flex algin-middle p-2" href={props.medium.enlace} rel="noreferrer" target="_blank">
                {bookIcon} {props.medium.titulo}
                </a>
            </>
        )
    }

    if(props.medium.extension === '.link'){
        return(
            <>
            <a href={props.medium.value} rel="noreferrer" target="_blank">{props.medium.description}</a>
            </>
        )
    }

    if(props.medium.extension === '.jpg'){
        return(
            <>
            <img src={props.medium.enlace} alt="" />
            </>
        )
    }
    
    if(props.medium.extension === '.mp4'){
        return(
            <>
            <p className="flex algin-middle p-2"> {eyeIcon} {props.medium.titulo}</p>
            <video width="97%" poster={PRELOAD_IMG} controls>
                <source src={props.medium.enlace}  type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            </>
        )
    }

    return (
        <span className="fixed w-full top-0-important flex justify-between bg-business-dark-blue-text shadow-md"></span>
    )
  }